import { useState } from "react";
import { kebabCase } from "lodash";
import AgilityRichText from "./AgilityRichText";

const FAQ = ({ ...props }) => {
  const { heading, description, faqs, type = "grey", className = ""} = props;

  return (
    <div className={`faq tw-container lg:tw-py-25 tw-py-8 ${className}`}>
      <div className="tw-max-w-[700px]">
        {!!heading &&
          <h2 className="tw-text-3.5xl tw-font-roboto tw-font-bold tw-mb-4">
            {heading}
          </h2>
        }
        {!!description &&
          <AgilityRichText
            html={description}
            className="tw-text-md tw-font-roboto tw-mb-8"
          />
        }
        {!!faqs?.length &&
          <div className="tw-flex tw-flex-col tw-gap-4">
            {faqs.map((faq, i) => (
              <FAQItem {...faq?.fields} key={i} type={type}/>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

const FAQItem = ({ question, answer, type = "grey"}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`${type === "white" ? "tw-bg-white tw-border" : "tw-bg-grey-500"}`}>
      <div
        className="tw-flex tw-justify-between tw-items-center tw-gap-3 tw-w-full tw-p-4"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className={`tw-font-roboto tw-m-0 tw-text-left tw-font-bold tw-normal-case ${type === "white" ? "" : "tw-text-2xl"}`}>
          {question}
        </h3>
        <svg
          width="48"
          height="48"
          className={isOpen ? "tw-transform" : "tw-rotate-180"}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 20L18 26L19.41 27.41L24 22.83L28.59 27.41L30 26L24 20Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      </div>
      <AgilityRichText
        id={kebabCase(question)}
        html={answer}
        className={`faq-richtext tw-pb-4 ${!isOpen ? "tw-hidden" : ""} ${
          type === "white" ? "[&>*]:!tw-text-sm tw-px-4" : "tw-font-roboto tw-text-xl tw-pl-11 tw-pr-4"
        }`}
      />
    </div>
  );
};
export default FAQ;
